(() => {
  'use strict';
  const widgetObservers = new Map();
  const movedWishlistPortals = new WeakSet();
  let pending = false;
  let positionTimer;
  let launcherElement;
  const launcherSelector = 'a[href*="wa.me"], a[href*="api.whatsapp"], [class*="whatsapp"], [id*="whatsapp"], [aria-label*="WhatsApp"], [title*="WhatsApp"], .joinchat__button, .chaty-widget .chaty-channel, iframe[src*="whatsapp"]';
  const widgetSelector = `.trustpilot-widget, ${launcherSelector}`;
  function positionScrollTop() {
    const button = document.querySelector('[data-scroll-top-button]');
    if (!button) return;
    const viewportWidth = document.documentElement.clientWidth;
    if (!launcherElement?.isConnected) {
      const candidates = document.querySelectorAll(launcherSelector);
      const matches = [...candidates].filter(element => {
        for (let ancestor = element; ancestor && ancestor !== document.body; ancestor = ancestor.parentElement) {
          if (getComputedStyle(ancestor).position === 'fixed') return true;
        }
        return false;
      }).map(element => ({element, rect: element.getBoundingClientRect()}))
        .filter(({rect}) => rect.width >= 24 && rect.width <= 100 && rect.height >= 24 && rect.height <= 100 && rect.right > viewportWidth / 2 && rect.bottom <= innerHeight && rect.bottom > innerHeight * .6)
        .sort((a, b) => b.rect.bottom - a.rect.bottom);
      launcherElement = matches[0]?.element;
    }
    const rect = launcherElement?.getBoundingClientRect();
    const launcher = rect?.width >= 24 && rect.width <= 100 && rect.height >= 24 && rect.height <= 100 && rect.right > viewportWidth / 2 && rect.bottom <= innerHeight && rect.bottom > innerHeight * .6 ? rect : null;
    if (!launcher) launcherElement = undefined;
    const bottom = launcher ? Math.ceil(innerHeight - launcher.top + 12) : null;
    const right = launcher ? Math.max(8, Math.round(viewportWidth - launcher.right + (launcher.width - 44) / 2)) : null;
    const update = (property, value) => {
      const next = value === null ? '' : value + 'px';
      if (button.style.getPropertyValue(property) === next) return;
      if (next) button.style.setProperty(property, next);
      else button.style.removeProperty(property);
    };
    update('--noise-top-bottom', bottom);
    update('--noise-top-right', right);
  }
  function refresh() {
    pending = false;
    positionScrollTop();
    document.querySelectorAll('button.nm-wishlist-open-list-button').forEach(button => {
      if (!button.getAttribute('aria-label')) button.setAttribute('aria-label', 'Lista dei desideri');
      if (!button.getAttribute('title')) button.setAttribute('title', 'Lista dei desideri');
    });
    document.querySelectorAll('[data-noise-trustpilot] .trustpilot-widget').forEach(widget => {
      if (!window.Trustpilot?.loadFromElement || widget.dataset.noiseLoaded) return;
      if (!widget.querySelector('iframe')) window.Trustpilot.loadFromElement(widget, true);
      widget.dataset.noiseLoaded = 'true';
    });
  }
  function schedule() {
    if (pending) return;
    pending = true;
    setTimeout(refresh, 80);
  }
  function schedulePosition() {
    clearTimeout(positionTimer);
    // Let touch scrolling finish before measuring fixed widgets or writing styles.
    positionTimer = setTimeout(positionScrollTop, 180);
  }
  function relevantNode(node) {
    return node.nodeType === 1 && (node.matches(widgetSelector) || node.querySelector(widgetSelector));
  }
  function start() {
    refresh();
    // Ignore unrelated carousel/review/counter updates instead of rescanning the page.
    const observer = new MutationObserver(records => {
      if (!records.some(record => [...record.addedNodes, ...record.removedNodes].some(relevantNode))) return;
      launcherElement = undefined;
      schedule();
    });
    observer.observe(document.body, {childList: true, subtree: true});
    document.addEventListener('shopify:section:load', schedule);
    window.addEventListener('resize', schedulePosition, {passive: true});
    window.addEventListener('scroll', schedulePosition, {passive: true});
    document.addEventListener('theme:variant:prices-updated', schedule);
    // Custom element initialization may happen without any light-DOM insertion.
    if (window.customElements) customElements.whenDefined('scalapay-widget').then(schedule);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start, {once: true});
  else start();
})();
